<template>
    <section class="responsiveSection promoBanner__wrapper padding-top-20">
        <div class="responsiveSection__grid">
            <div class="promoBanner margin-vertical-50 margin-horizontal-20">
                <div class="flex pos-relative">
                    <div class="width70 flex__item--center">
                        <h2 class="sectionRooftitle">
                            {{ bannerTitle }}
                        </h2>
                        <h3 class="responsiveText display-block margin-horizontal-auto h3 margin-bottom-0 text-color--white">
                            {{ bannerHeadline }}
                        </h3>
                        <p class="text-color--white margin-top-20">
                            {{ bannerDescription }}
                        </p>
                        <div v-html="bannerItems">
                        </div>

                        <div class="margin-top-20">
                            <a
                                :href="corporate ? caPath : paPath"
                                class="button button--medium button--primary"
                                :data-gtm="`search__account--overview--${ currentTab }`">
                                {{ bannerButton }}
                            </a>
                        </div>
                    </div>
                    <div class="width30 margin-top-s-20 banner__image--hide flex__item--center">
                        <div class="contentCard__image">
                            <img
                                :src="bannerSrc"
                                alt="banner"
                                width="355"
                                height="253">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import { defineComponent } from 'vue';

    import Translator from 'tools/trans';

    export default defineComponent({
        name: 'Banner',

        props: {
            currentTab: { type: String, required: false, default: 'all' },
            corporate: { type: Boolean, required: false, default: true },
        },
        data() {
            return {
                bannerTitle: this.bannerTitleFunc(),
                bannerSrc: this.bannerSrcFunc(),
                bannerHeadline: this.bannerHeadlineFunc(),
                bannerButton: this.bannerButtonFunc(),
                bannerDescription: this.bannerDescriptionFunc(),
                bannerItems: this.bannerItemsFunc(),
                paPath: window.stGlobals.path.accountsOverview.pa,
                caPath: window.stGlobals.path.accountsOverview.ca,
            };
        },
        setup(props) {
            function bannerTitleFunc() {
                switch (props.currentTab) {
                    case 'statistics':
                        return Translator.trans('STATISTIC_BANNER_TITLE');
                    case 'all':
                        return Translator.trans('ALL_BANNER_TITLE');
                    case 'reports':
                        return Translator.trans('REPORT_BANNER_TITLE');
                    case 'eCommerceInsights':
                        return Translator.trans('ECOMMERCE_BANNER_TITLE');
                    case 'consumerInsights':
                        return Translator.trans('CONSUMER_BANNER_TITLE');
                    case 'marketInsights':
                        return Translator.trans('MARKET_BANNER_TITLE');
                    default:
                        return Translator.trans('ALL_BANNER_TITLE');
                }
            }
            function bannerSrcFunc() {
                switch (props.currentTab) {
                    case 'statistics':
                        return 'https://cdn.statcdn.com/Statistic/180000/183379-blank-355.png';
                    case 'all':
                        return 'https://cdn.statcdn.com/Statistic/180000/183379-blank-355.png';
                    case 'reports':
                        return 'https://cdn.statcdn.com/static/img/accountOverview/sectionContents/ao-content-img-reports-landscape_x2.png';
                    case 'eCommerceInsights':
                        return 'https://cdn.statcdn.com/static/img/accountOverview/sectionContents/ao-content-img-ecommercedb.png';
                    case 'consumerInsights':
                        return 'https://cdn.statcdn.com/static/img/accountOverview/sectionContents/ao-content-img-gcs.png';
                    case 'marketInsights':
                        return 'https://cdn.statcdn.com/static/img/accountOverview/sectionContents/ao-content-img-outlooks.png';
                    default:
                        return 'https://cdn.statcdn.com/Statistic/180000/183379-blank-355.png';
                }
            }
            function bannerHeadlineFunc() {
                switch (props.currentTab) {
                    case 'statistics':
                        return Translator.trans('STATISTIC_BANNER_HEADLINE');
                    case 'all':
                        return Translator.trans('ALL_BANNER_HEADLINE');
                    case 'reports':
                        return Translator.trans('REPORT_BANNER_HEADLINE');
                    case 'eCommerceInsights':
                        return Translator.trans('ECOMMERCE_BANNER_HEADLINE');
                    case 'consumerInsights':
                        return Translator.trans('CONSUMER_BANNER_HEADLINE');
                    case 'marketInsights':
                        return Translator.trans('MARKET_BANNER_HEADLINE');
                    default:
                        return Translator.trans('ALL_BANNER_HEADLINE');
                }
            }
            function bannerDescriptionFunc() {
                switch (props.currentTab) {
                    case 'statistics':
                        return Translator.trans('STATISTIC_BANNER_DESCRIPTION');
                    case 'all':
                        return Translator.trans('ALL_BANNER_DESCRIPTION');
                    case 'reports':
                        return Translator.trans('REPORT_BANNER_DESCRIPTION');
                    case 'eCommerceInsights':
                        return Translator.trans('ECOMMERCE_BANNER_DESCRIPTION');
                    case 'consumerInsights':
                        return Translator.trans('CONSUMER_BANNER_DESCRIPTION');
                    case 'marketInsights':
                        return Translator.trans('MARKET_BANNER_DESCRIPTION');
                    default:
                        return Translator.trans('ALL_BANNER_DESCRIPTION');
                }
            }
            function bannerButtonFunc() {
                switch (props.currentTab) {
                    case 'statistics':
                        return Translator.trans('STATISTIC_BANNER_BUTTON');
                    case 'all':
                        return Translator.trans('ALL_BANNER_BUTTON');
                    case 'reports':
                        return Translator.trans('REPORT_BANNER_BUTTON');
                    case 'eCommerceInsights':
                        return Translator.trans('ECOMMERCE_BANNER_BUTTON');
                    case 'consumerInsights':
                        return Translator.trans('CONSUMER_BANNER_BUTTON');
                    case 'marketInsights':
                        return Translator.trans('MARKET_BANNER_BUTTON');
                    default:
                        return Translator.trans('ALL_BANNER_BUTTON');
                }
            }
            function bannerItemsFunc() {
                switch (props.currentTab) {
                    case 'statistics':
                        return Translator.trans('STATISTIC_BANNER_ITEMS');
                    case 'all':
                        return Translator.trans('ALL_BANNER_ITEMS');
                    case 'reports':
                        return Translator.trans('REPORT_BANNER_ITEMS');
                    case 'eCommerceInsights':
                        return Translator.trans('ECOMMERCE_BANNER_ITEMS');
                    case 'consumerInsights':
                        return Translator.trans('CONSUMER_BANNER_ITEMS');
                    case 'marketInsights':
                        return Translator.trans('MARKET_BANNER_ITEMS');
                    default:
                        return Translator.trans('ALL_BANNER_ITEMS');
                }
            }

            return {
                bannerTitleFunc,
                bannerSrcFunc,
                bannerHeadlineFunc,
                bannerButtonFunc,
                bannerDescriptionFunc,
                bannerItemsFunc,
            };
        },
    });
</script>

